import React, { KeyboardEvent, useEffect, useRef } from "react";

import { Input as AntInput, InputRef } from "antd";

type InputInlineProps = {
  value: string;
  error?: string;
  maxLength?: number;
  className?: string;
  dataTestId?: string;
  onChange: (value: string) => void;
  onSave: () => void;
  onCancel: () => void;
};

/** Edits a text value in place: selects the text on mount, Enter saves, Escape cancels. */
export const InputInline = ({ value, error, maxLength, className = "", dataTestId = "", onChange, onSave, onCancel }: InputInlineProps) => {
  const inputRef = useRef<InputRef>(null);

  useEffect(() => {
    inputRef.current?.focus({ cursor: "all" });
  }, []);

  const handleKeyDown = (e: KeyboardEvent<HTMLInputElement>) => {
    if (e.key === "Enter") onSave();
    else if (e.key === "Escape") onCancel();
  };

  return (
    <div className={`input-inline ${className}`}>
      <AntInput
        ref={inputRef}
        value={value}
        maxLength={maxLength}
        className={`input-inline-input ${error ? "input-inline-input-error" : ""}`}
        data-testid={dataTestId}
        onChange={(e) => onChange(e.target.value)}
        onKeyDown={handleKeyDown}
      />
      {error && <span className="input-inline-error">{error}</span>}
    </div>
  );
};
